// extracted by mini-css-extract-plugin
export var width100 = "C_s d_s";
export var design3Pos = "C_t6 d_X";